<div class="line {{type}}" [ngStyle]="style()">
  <div class="arrow"></div>
</div>
